import React from "react";
import { Box, styled, Typography } from "@mui/material";
import { fontWeights } from "@themes";

const Frame = styled(Box)(({ theme }) => ({
  display: "inline-flex",
  padding: "8px 12px",
  flexDirection: "column",
  alignItems: "flex-start",
  borderRadius: 32,
  backgroundColor: theme.vars.palette.base.secondary,
  mixBlendMode: "luminosity",
  height: "100%",
}));

const Content = styled((props) => (
  <Typography variant="caption1" {...props} />
))(({ theme }) => ({
  color: theme.vars.palette.base.background,
  fontWeight: fontWeights.MEDIUM,
}));

const Tag = ({ tag }) => {
  return (
    <Frame>
      <Content>{tag}</Content>
    </Frame>
  );
};

export default Tag;
